var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "sm" },
    on: { close: () => _vm.$emit("closeRequestMoreHoursDeclineModal") },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative h-72" }, [
              _c(
                "span",
                {
                  staticClass:
                    "cursor-pointer flex items-center justify-center absolute top-0 right-0 z-100",
                  on: {
                    click: () => _vm.$emit("closeRequestMoreHoursDeclineModal"),
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "mb-0.5",
                      attrs: {
                        width: "26",
                        height: "26",
                        viewBox: "0 0 13 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M10.728 1.75737C8.38605 -0.584572 4.58465 -0.584572 2.24271 1.75737C-0.0992269 4.0993 -0.0992267 7.90071 2.24271 10.2426C4.58465 12.5846 8.38605 12.5846 10.728 10.2426C13.0699 7.90071 13.0699 4.0993 10.728 1.75737ZM7.75814 8.12133L6.48535 6.84853L5.21256 8.12133C4.97921 8.35467 4.59738 8.35467 4.36403 8.12133C4.13069 7.88798 4.13069 7.50614 4.36403 7.2728L5.63682 6.00001L4.36403 4.72721C4.13069 4.49387 4.13069 4.11203 4.36403 3.87869C4.59738 3.64534 4.97921 3.64534 5.21256 3.87869L6.48535 5.15148L7.75814 3.87869C7.99149 3.64534 8.37333 3.64534 8.60667 3.87869C8.84002 4.11203 8.84002 4.49387 8.60667 4.72721L7.33388 6.00001L8.60667 7.2728C8.84002 7.50614 8.84002 7.88798 8.60667 8.12133C8.37333 8.35467 7.99149 8.35467 7.75814 8.12133Z",
                          fill: "#1A7BEE",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c("div", { staticClass: "w-full space-y-2 h-52 relative z-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex font-bold space-x-1",
                    attrs: { id: "modal-heading" },
                  },
                  [_c("p", [_vm._v("Decline Requested Hours ")])]
                ),
                _c("div", { staticClass: "w-full space-y-1" }, [
                  _c("p", { staticClass: "font-bold" }, [_vm._v("Add reason")]),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.decline_reason,
                        expression: "decline_reason",
                      },
                    ],
                    staticClass:
                      "focus:outline-none border border-gray-300 rounded-lg w-full h-40 resize-none p-3 text-gray-500 placeholder-gray-300",
                    attrs: { placeholder: "Reason" },
                    domProps: { value: _vm.decline_reason },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.decline_reason = $event.target.value
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "w-full flex justify-end mt-10",
                    attrs: { id: "decline-buttons" },
                  },
                  [
                    _c("UiButton", {
                      attrs: {
                        disabled: !_vm.canSave,
                        variant: "secondary",
                        buttonText: "Decline Request",
                        processing: _vm.processing,
                      },
                      on: { click: _vm.declineRequest },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }